/**
 * Generates email-safe HTML for HomeGo Removals quotation email
 * Updated design matching the reference screenshots
 * Uses table-based layout for maximum email client compatibility
 */

// HomeGo logo
const SUNNY_IMAGE_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

// Real HomeGo team images
const HOMEGO_DBS_TEAM = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/0koj4d3w_IMG_6794.PNG";

// Trust partner logos
const CHECKATRADE_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/ebu7qu1u_logos-checkatrade.png";
const GETAMOVER_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/fxcpado8_download.jpg";
// Swapped - download.png is Yell (yellow), unnamed.webp is Bark (dark blue)
const BARK_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/ynl845us_download.png"; // Dark blue bark - was incorrectly labeled
const YELL_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/hs0febfn_unnamed.webp"; // Yellow Yell - was incorrectly labeled
const TRUSTPILOT_VERIFIED_LOGO = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/j8xkemf3_download-1.jpg";

export const generateEmailHTML = (data) => {
  const {
    quotation_reference = "HG-00001",
    customer_name = "Customer",
    property_size = "2-bedroom",
    moving_from = "SW1A 1AA",
    moving_to = "E1 6AN",
    moving_date = "Friday, 15 March 2026",
    crew_size = "2 Crew Members",
    vehicle_type = "3.5 Tonne Truck",
    deposit_amount = 95,
    
    // Consultant
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    consultant_image = SUNNY_IMAGE_URL,
    
    // Additional notes
    additional_notes = "",
    
    // Package prices
    economy_move_price = 385,
    comfort_move_price = 485,
    comfort_plus_price = 735,
    premium_price = 985,
    man_and_van_price = 285,
    loading_crew_price = 45,
    
    // Which packages to show
    show_economy = true,
    show_comfort = true,
    show_comfort_plus = true,
    show_premium = true,
    show_man_and_van = true,
    show_loading_crew = true,
    
    // Custom Message
    custom_recommendation_message = "",
    show_custom_message = false,
    
    // Crew Recommendation
    booked_crew_count = "",
    booked_van_type = "",
    recommended_crew_count = "",
    recommended_van_type = "",
    crew_upgrade_cost = "150",
    show_crew_recommendation = false,

    // Working Hours & Overtime Policy
    show_overtime_policy = false,
    overtime_rate = "120",
    work_hours_start = "9:00 AM",
    work_hours_end = "5:00 PM",
    
    // Multiple Locations
    pickup_location_1 = "",
    pickup_location_2 = "",
    dropoff_location_1 = "",
    dropoff_location_2 = "",
    stop_location_1 = "",
    stop_location_2 = "",
    show_extra_pickups = false,
    show_extra_dropoffs = false,
    show_stops = false,
    
    // Special Requirements
    special_requirements = "",
    show_special_requirements = false,
  } = data;

  // Additional notes section HTML (only show if notes exist)
  const additionalNotesHTML = additional_notes ? `
          <!-- Additional Notes -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFFEF5; border: 2px solid #D4AF37; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #B8860B;">
                      &#128221; Additional Notes
                    </h4>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; white-space: pre-line;">
                      ${additional_notes}
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Custom Message section (only show if enabled and has content)
  const customMessageHTML = show_custom_message && custom_recommendation_message ? `
          <!-- Personal Message from HomeGo -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F3E8FF; border: 2px solid #9333EA; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #7C3AED; text-transform: uppercase; letter-spacing: 1px;">
                      &#128172; A Message From Our Team
                    </h4>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                      ${custom_recommendation_message}
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Crew Recommendation section for Quote (only show if enabled)
  const crewRecommendationHTML = show_crew_recommendation && booked_crew_count ? `
          <!-- Crew Upgrade Recommendation -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF3C7; border: 2px solid #F59E0B; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #92400E; text-transform: uppercase; letter-spacing: 1px;">
                      🚚 Crew Upgrade Recommendation
                    </h4>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 10px; background-color: #FFF; border-radius: 6px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">
                            <strong>This Quote Includes:</strong><br/>
                            ${booked_crew_count} Crew Members + ${booked_van_type}
                          </p>
                        </td>
                      </tr>
                      <tr><td style="height: 10px;"></td></tr>
                      <tr>
                        <td style="padding: 10px; background-color: #D1FAE5; border-radius: 6px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #065F46;">
                            <strong>💡 For a faster & smoother move we recommend:</strong><br/>
                            ${recommended_crew_count} Crew Members + ${recommended_van_type}
                          </p>
                          <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #047857;">
                            Extra Cost: +£${crew_upgrade_cost}
                          </p>
                          <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #047857;">
                            ⏱️ Save time & reduce stress with extra help!
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Working Hours & Overtime Policy section (only show if enabled)
  const overtimePolicyHTML = show_overtime_policy ? `
          <!-- Working Hours & Overtime Policy -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 12px; overflow: hidden; border: 2px solid #1a1a1a;">
                <tr>
                  <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 15px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 15px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      ⏰ Working Hours &amp; Overtime Policy
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #FAFAF7; padding: 20px;">
                    <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.7;">
                      Our crew's standard working day runs from <strong>${work_hours_start}</strong> to <strong>${work_hours_end}</strong>, in line with UK working practice for removals crews.
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF2F2; border: 1px solid #FCA5A5; border-radius: 8px;">
                      <tr>
                        <td style="padding: 12px 15px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #991B1B; line-height: 1.6;">
                            <strong>Overtime:</strong> Any work required after ${work_hours_end} is chargeable at <strong style="font-size: 16px;">£${overtime_rate} per hour</strong> (or part thereof), payable on the day.
                          </p>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #065F46; line-height: 1.6; background-color: #ECFDF5; border-radius: 8px; padding: 12px 15px;">
                      💡 <strong>Avoid overtime charges:</strong> booking the recommended crew size means your move completes comfortably within standard hours — faster, smoother, and no extra cost on the day.
                    </p>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #888; line-height: 1.5;">
                      By confirming your booking you accept these working hours and overtime terms, which form part of your agreement with HomeGo Removals &amp; Packing Ltd.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Multiple Locations HTML (pickups, drop-offs, stops)
  const hasExtraLocations = (show_extra_pickups && (pickup_location_1 || pickup_location_2)) || 
                           (show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2)) ||
                           (show_stops && (stop_location_1 || stop_location_2));
  
  const multipleLocationsHTML = hasExtraLocations ? `
          <!-- Multiple Locations -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF7ED; border: 2px solid #F97316; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #C2410C; text-transform: uppercase; letter-spacing: 1px;">
                      📍 Multiple Locations
                    </h4>
                    
                    ${show_extra_pickups && (pickup_location_1 || pickup_location_2) ? `
                    <div style="margin-bottom: 15px;">
                      <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">PICKUP LOCATIONS:</p>
                      <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                        <strong>1.</strong> ${moving_from} (Main)<br/>
                        ${pickup_location_1 ? `<strong>2.</strong> ${pickup_location_1}<br/>` : ''}
                        ${pickup_location_2 ? `<strong>3.</strong> ${pickup_location_2}<br/>` : ''}
                      </p>
                    </div>
                    ` : ''}
                    
                    ${show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2) ? `
                    <div style="margin-bottom: 15px;">
                      <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">DROP-OFF LOCATIONS:</p>
                      <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                        <strong>1.</strong> ${moving_to} (Main)<br/>
                        ${dropoff_location_1 ? `<strong>2.</strong> ${dropoff_location_1}<br/>` : ''}
                        ${dropoff_location_2 ? `<strong>3.</strong> ${dropoff_location_2}<br/>` : ''}
                      </p>
                    </div>
                    ` : ''}
                    
                    ${show_stops && (stop_location_1 || stop_location_2) ? `
                    <div>
                      <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">STOPS ALONG THE WAY:</p>
                      <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                        ${stop_location_1 ? `<strong>Stop 1:</strong> ${stop_location_1}<br/>` : ''}
                        ${stop_location_2 ? `<strong>Stop 2:</strong> ${stop_location_2}<br/>` : ''}
                      </p>
                    </div>
                    ` : ''}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Special Requirements HTML
  const specialRequirementsHTML = show_special_requirements && special_requirements ? `
          <!-- Special Requirements -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF1F2; border: 2px solid #F43F5E; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #BE123C; text-transform: uppercase; letter-spacing: 1px;">
                      ⚠️ Special Requirements
                    </h4>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                      ${special_requirements}
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  // Vehicle image URL (the one provided by user)
  const vehicleImageUrl = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

  // Generate package cards HTML - Consistent professional sizing
  const packagesHTML = `
    ${show_loading_crew ? `
    <!-- Loading Crew Only Package -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #10B981; border-radius: 12px; overflow: hidden; background-color: #ECFDF5;">
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #10B981; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      👷 LABOUR ONLY
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #065F46; text-transform: uppercase; letter-spacing: 1px;">
                      LOADING CREW ONLY
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 10px;">
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #065F46;">
                      &pound;${loading_crew_price}<span style="font-size: 16px; font-weight: normal;">/hr per person</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Professional loading crew
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; No van included - you provide transport
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading &amp; unloading assistance
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Hourly rate - pay for time used
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}

    ${show_man_and_van ? `
    <!-- Man and Van Package -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #3B82F6; border-radius: 12px; overflow: hidden; background-color: #EFF6FF;">
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #3B82F6; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      🚐 BASIC
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #1E40AF; text-transform: uppercase; letter-spacing: 1px;">
                      MAN &amp; VAN
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 10px;">
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #1E40AF;">
                      &pound;${man_and_van_price}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; 1 Driver + Van
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading assistance
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Perfect for small moves
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}

    ${show_economy ? `
    <!-- Economy Move Package -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #E5E7EB; border-radius: 12px; overflow: hidden;">
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #374151; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      BUDGET-FRIENDLY
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #000000; text-transform: uppercase; letter-spacing: 1px;">
                      ECONOMY MOVE
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 10px;">
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #000000;">
                      &pound;${economy_move_price}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading &amp; unloading
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Placing boxes in correct rooms
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}

    ${show_comfort ? `
    <!-- Comfort Move Package - RECOMMENDED -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 3px solid #D4AF37; border-radius: 12px; overflow: hidden; background-color: #FFFEF5;">
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      ⭐ RECOMMENDED
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #000000; text-transform: uppercase; letter-spacing: 1px;">
                      COMFORT MOVE
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 10px;">
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #000000;">
                      &pound;${comfort_move_price}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Dismantling &amp; reassembling furniture
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading &amp; unloading
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Placing boxes in correct rooms
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}

    ${show_comfort_plus ? `
    <!-- Comfort Plus Package - MOST POPULAR -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 3px solid #000000; border-radius: 12px; overflow: hidden;">
          <tr>
            <td style="background-color: #000000; padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      ★ MOST POPULAR
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      COMFORT PLUS — FULL PACKING
                    </h3>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #000000;">
                      &pound;${comfort_plus_price}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Full packing of all items
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Fragile packing included
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Dismantling &amp; reassembling
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading &amp; unloading
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Items placed in correct rooms
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}

    ${show_premium ? `
    <!-- Premium Package -->
    <tr>
      <td style="padding: 8px 0;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 3px solid #8B5CF6; border-radius: 12px; overflow: hidden; background: linear-gradient(135deg, #F5F3FF 0%, #EDE9FE 100%);">
          <tr>
            <td style="padding: 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <span style="display: inline-block; background-color: #8B5CF6; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; padding: 5px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
                      👑 PREMIUM SERVICE
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 12px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #5B21B6; text-transform: uppercase; letter-spacing: 1px;">
                      PREMIUM — PACK, MOVE &amp; UNPACK
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 10px;">
                    <span style="font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #5B21B6;">
                      &pound;${premium_price}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="padding-top: 15px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Full packing of all items
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Fragile packing included
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Dismantling &amp; reassembling
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Loading &amp; unloading
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #4B5563;">
                          &#10003; Items placed in correct rooms
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #8B5CF6; font-weight: bold;">
                          &#10003; Full unpacking at destination
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 5px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #8B5CF6; font-weight: bold;">
                          &#10003; Removal of all packing materials
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    ` : ''}
  `;

  return `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>HomeGo Removals - Quotation ${quotation_reference}</title>
  <style type="text/css">
    /* Mobile Responsive Styles */
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; }
      .mobile-padding { padding-left: 15px !important; padding-right: 15px !important; }
      .mobile-stack { display: block !important; width: 100% !important; }
      .mobile-center { text-align: center !important; }
      .mobile-font-large { font-size: 26px !important; }
      .mobile-font-medium { font-size: 14px !important; }
      .price-text { font-size: 28px !important; }
      .header-padding { padding: 20px !important; }
      .content-padding { padding: 15px !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #F4F4F5; font-family: Helvetica, Arial, sans-serif;">
  <!-- Preheader (Preview text in inbox) -->
  <div style="display: none; max-height: 0; overflow: hidden; mso-hide: all;">
    Your personalized moving quotation from HomeGo Removals - Ref: ${quotation_reference}
  </div>
  
  <!-- Main Container -->
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F4F4F5;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <!-- Email Container -->
        <table class="email-container" border="0" cellpadding="0" cellspacing="0" width="600" style="max-width: 600px; width: 100%; background-color: #FFFFFF; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background-color: #000000; padding: 30px 40px; text-align: center;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h1 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 32px; font-weight: bold; color: #FFFFFF; letter-spacing: 1px;">
                      Home<span style="color: #D4AF37;">Go</span>
                    </h1>
                    <p style="margin: 5px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; letter-spacing: 2px; text-transform: uppercase;">
                      REMOVALS &amp; PACKING LTD
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Tagline Banner -->
          <tr>
            <td style="background-color: #D4AF37; padding: 12px 40px; text-align: center;">
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #000000;">
                The UK's Most Trusted Removals Company
              </p>
            </td>
          </tr>

          <!-- Quotation Reference -->
          <tr>
            <td style="background-color: #D4AF37; padding: 15px 40px; text-align: center;">
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000;">
                QUOTATION REFERENCE: <span style="font-size: 18px;">${quotation_reference}</span>
              </p>
            </td>
          </tr>

          <!-- Greeting -->
          <tr>
            <td style="padding: 30px 40px 20px;">
              <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 16px; color: #333333;">
                Dear <strong>${customer_name}</strong>,
              </p>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666; line-height: 1.6;">
                Thank you for getting in touch with HomeGo Removals &amp; Packing Ltd regarding your upcoming house move. Please find your personalised quotation details below.
              </p>
            </td>
          </tr>

          <!-- Customer Details Section -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; overflow: hidden;">
                <!-- Yellow Header -->
                <tr>
                  <td style="background-color: #D4AF37; padding: 15px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000; text-transform: uppercase; letter-spacing: 1px;">
                      CUSTOMER DETAILS
                    </h3>
                  </td>
                </tr>
                <!-- Black Body -->
                <tr>
                  <td style="background-color: #000000; padding: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999; width: 40%;">
                          Customer Name:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${customer_name.toUpperCase()}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Property Size:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${property_size}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Moving From:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${moving_from}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Moving To:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${moving_to}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Moving Date:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${moving_date}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Crew Size:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${crew_size}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #999999;">
                          Vehicle Type:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; font-weight: bold;">
                          ${vehicle_type}
                        </td>
                      </tr>
                    </table>
                    <!-- Vehicle Info Note -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top: 15px; background-color: #1a1a1a; border-radius: 6px;">
                      <tr>
                        <td style="padding: 12px 15px;">
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="padding-right: 10px; vertical-align: top;">
                                <span style="font-size: 18px;">&#128161;</span>
                              </td>
                              <td style="font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #CCCCCC; line-height: 1.5;">
                                All vehicles are HomeGo-branded and fully equipped with furniture blankets, straps, and trolleys.
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Quotation Options Section -->
          <tr>
            <td style="padding: 0 40px 10px;">
              <h2 style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 22px; font-weight: bold; color: #000000; text-transform: uppercase; border-bottom: 3px solid #D4AF37; padding-bottom: 10px; display: inline-block;">
                QUOTATION OPTIONS
              </h2>
              <p style="margin: 10px 0 20px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666; line-height: 1.5;">
                Kindly review the options below and select the service that best suits your requirements:
              </p>
            </td>
          </tr>

          <!-- Package Options -->
          <tr>
            <td style="padding: 0 40px 20px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                ${packagesHTML}
              </table>
            </td>
          </tr>

          <!-- Booking & Peace of Mind Section -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; overflow: hidden;">
                <!-- Yellow Header -->
                <tr>
                  <td style="background-color: #D4AF37; padding: 15px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000; text-transform: uppercase; letter-spacing: 1px;">
                      BOOKING &amp; PEACE OF MIND
                    </h3>
                  </td>
                </tr>
                <!-- Black Body -->
                <tr>
                  <td style="background-color: #000000; padding: 25px 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; line-height: 1.6;">
                          &bull; A <span style="color: #D4AF37; font-weight: bold;">&pound;${deposit_amount} deposit</span> is required to secure your booking
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; line-height: 1.6;">
                          &bull; You may reserve your moving date even if it is not yet confirmed
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; line-height: 1.6;">
                          &bull; Date changes are <strong>free of charge</strong>, subject to availability
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #FFFFFF; line-height: 1.6;">
                          &bull; <span style="color: #D4AF37; font-weight: bold;">&pound;50,000</span> Goods in Transit Insurance included for your peace of mind
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Message Section -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6;">
                Our experienced and professional team is committed to making your move smooth, safe, and completely stress-free.
              </p>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6;">
                Please let us know which option you would like to proceed with, along with your preferred moving date, and we will be happy to secure your booking.
              </p>
            </td>
          </tr>

          ${additionalNotesHTML}

          ${multipleLocationsHTML}

          ${specialRequirementsHTML}

          ${crewRecommendationHTML}

          ${overtimePolicyHTML}

          ${customMessageHTML}

          <!-- Consultant Section - Thomas Jacobs with Meta-style Verified Badge -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #E5E7EB; border-radius: 12px; overflow: hidden;">
                <tr>
                  <td style="padding: 25px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="width: 80px; vertical-align: top;">
                          <!-- Profile Picture with Meta-style Blue Verified Badge -->
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="position: relative;">
                                <img src="${consultant_image}" alt="${consultant_name}" width="80" style="width: 80px; height: auto; border-radius: 8px; border: 2px solid #D4AF37; background-color: #FFFFFF; display: block;" />
                              </td>
                            </tr>
                            <tr>
                              <td align="right" style="padding-top: -18px; margin-top: -18px;">
                                <!-- Meta-style Blue Verified Badge -->
                                <img src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Twitter_Verified_Badge.svg" alt="Verified" width="22" height="22" style="width: 22px; height: 22px; margin-top: -22px; margin-left: 45px; display: block;" />
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td style="vertical-align: top; padding-left: 15px;">
                          <h4 style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #000000;">
                            ${consultant_name}
                            <img src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Twitter_Verified_Badge.svg" alt="Verified" width="16" height="16" style="width: 16px; height: 16px; vertical-align: middle; margin-left: 5px;" />
                          </h4>
                          <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #666666;">
                            ${consultant_title} | HomeGo Removals
                          </p>
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="padding-right: 15px;">
                                <a href="tel:07440414548" style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 13px; font-weight: bold; text-decoration: none; padding: 8px 16px; border-radius: 20px;">
                                  📞 Call Thomas
                                </a>
                              </td>
                              <td>
                                <a href="mailto:thomasjacobs@homego-removals.com" style="font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #3B82F6; text-decoration: none;">
                                  ✉️ thomasjacobs@homego-removals.com
                                </a>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Vehicle Image (Small) -->
          <tr>
            <td style="padding: 0 40px 30px;" align="center">
              <img src="${vehicleImageUrl}" alt="HomeGo Removals Logo" style="width: 320px; max-width: 100%; height: auto; display: block;" />
            </td>
          </tr>

          <!-- Trust Badges -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="padding: 0 15px; text-align: center;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #666666;">
                            &#9733; Trustpilot
                          </p>
                          <p style="margin: 2px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                            Trusted Removal Company
                          </p>
                        </td>
                        <td style="padding: 0 15px; border-left: 1px solid #E5E7EB; text-align: center;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #666666;">
                            &#128106; 500+ Families
                          </p>
                          <p style="margin: 2px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                            Trusted Us
                          </p>
                        </td>
                        <td style="padding: 0 15px; border-left: 1px solid #E5E7EB; text-align: center;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #666666;">
                            &#128737; Fully Insured
                          </p>
                          <p style="margin: 2px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                            Up to &pound;50,000
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #000000; padding: 30px 40px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h4 style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 22px; font-weight: bold; color: #D4AF37;">
                      Home<span style="color: #FFFFFF;">Go</span> Removals &amp; Packing Ltd
                    </h4>
                    <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #D4AF37; font-weight: bold;">
                      "The UK's Most Trusted Removals Company"
                    </p>
                  </td>
                </tr>
                <!-- Social + Contact Row -->
                <tr>
                  <td align="center" style="padding: 15px 0;">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <!-- Social Icons -->
                        <td style="padding: 0 8px;">
                          <a href="https://facebook.com/homegoremovals" target="_blank" style="text-decoration: none;">
                            <img src="https://cdn-icons-png.flaticon.com/32/733/733547.png" alt="Facebook" width="22" height="22" style="display: block;" />
                          </a>
                        </td>
                        <td style="padding: 0 8px;">
                          <a href="https://instagram.com/homegoremovals" target="_blank" style="text-decoration: none;">
                            <img src="https://cdn-icons-png.flaticon.com/32/733/733558.png" alt="Instagram" width="22" height="22" style="display: block;" />
                          </a>
                        </td>
                        <td style="padding: 0 8px;">
                          <a href="https://twitter.com/homegoremovals" target="_blank" style="text-decoration: none;">
                            <img src="https://cdn-icons-png.flaticon.com/32/733/733579.png" alt="Twitter" width="22" height="22" style="display: block;" />
                          </a>
                        </td>
                        <!-- Divider -->
                        <td style="padding: 0 12px; color: #444;">|</td>
                        <!-- WhatsApp Small Button -->
                        <td style="padding: 0 6px;">
                          <a href="https://wa.me/447440414548?text=Hi,%20I%20have%20a%20question%20about%20my%20quote%20(Ref:%20${quotation_reference})" style="display: inline-block; background-color: #25D366; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 11px; font-weight: bold; text-decoration: none; padding: 6px 12px; border-radius: 15px;">
                            💬 WhatsApp
                          </a>
                        </td>
                        <!-- Call Thomas Small Button -->
                        <td style="padding: 0 6px;">
                          <a href="tel:07440414548" style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 11px; font-weight: bold; text-decoration: none; padding: 6px 12px; border-radius: 15px;">
                            📞 Call Thomas
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding-top: 15px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #FFFFFF;">
                      Registered in England &amp; Wales | Company Registration No: <span style="color: #D4AF37; font-weight: bold;">16811153</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding-top: 10px;">
                    <a href="https://www.homego-removals.com" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #D4AF37; text-decoration: none;">
                      www.homego-removals.com
                    </a>
                  </td>
                </tr>
                <!-- Physical Address (Required by CAN-SPAM) -->
                <tr>
                  <td align="center" style="padding-top: 15px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                      HomeGo Removals &amp; Packing Ltd<br>
                      UK's Nationwide Premium Moving Company<br>
                      Tel: 0330 043 4791
                    </p>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding-top: 20px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #666666;">
                      &copy; HomeGo Removals &amp; Packing Ltd. All rights reserved.
                    </p>
                  </td>
                </tr>
                <!-- Unsubscribe Link (Helps Deliverability) -->
                <tr>
                  <td align="center" style="padding-top: 10px; padding-bottom: 10px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888888;">
                      This email was sent regarding your moving enquiry.<br>
                      If you no longer wish to receive emails, please reply with "unsubscribe".
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
        <!-- End Email Container -->
      </td>
    </tr>
  </table>
  <!-- End Main Container -->
</body>
</html>
`;
};

export default generateEmailHTML;
